module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"help":"Hilfe"},"en":{"help":"Help"}}')
  delete Component.options._Ctor
}
